module.exports = __webpack_public_path__ + "images/dingtalk/init-document-e8295e465493f21659d0eae81dbc24ae.png";